export default __webpack_public_path__ + "static/media/logo.c37be3b1.png";